<template>
  <div class="flex">
    <div class="flex-1 px-4">
      <h5 class="text-base font-normal">
        {{ getTriggerName(automation.triggerName) }}
      </h5>
      <ul>
        <li v-for="(value, key) in automation.triggerProps" :key="key" class="text-sm">
          <span>{{ key }}</span
          >: {{ value }}
        </li>
      </ul>
    </div>
    <div class="flex-1 px-4">
      <h5 class="text-base font-normal">
        {{ getActionName(automation.actionName) }}
      </h5>
      <ul>
        <li
          v-for="(value, key) in automation.actionProps"
          :key="key"
          class="text-sm break-all whitespace-pre-line"
        >
          <span>{{ key }}</span
          >: {{ value }}
        </li>
      </ul>
    </div>

    <div class="px-4">
      <VDropdown v-if="$membershipHasPermissionTo('delete automations')" right>
        <template #button="dropdownProps">
          <button class="btn btn-ghost px-3" @click="dropdownProps.open">
            <FontAwesomeIcon icon="ellipsis-v" fixed-width />
          </button>
        </template>

        <template #default="dropdownProps">
          <VDropdownMenu>
            <a
              v-if="$membershipHasPermissionTo('delete automations')"
              role="button"
              :class="[
                'block',
                'px-4',
                'py-2',
                'hover:bg-gray-200',
                'transition-color',
                'transition-fast',
                'text-right',
              ]"
              @click="dropdownProps.close(() => $emit('automation-edit', automation))"
              >Edit</a
            >
            <a
              v-if="$membershipHasPermissionTo('delete automations')"
              role="button"
              :class="[
                'block',
                'px-4',
                'py-2',
                'hover:bg-gray-200',
                'transition-color',
                'transition-fast',
                'text-right',
              ]"
              @click="dropdownProps.close(() => $emit('automation-delete', automation))"
              >Remove</a
            >
          </VDropdownMenu>
        </template>
      </VDropdown>
    </div>
  </div>
</template>

<script>
import VDropdown from '@/components/Common/VDropdown.vue';
import VDropdownMenu from '@/components/Common/VDropdownMenu.vue';

const CONTACT_SUBMIT_FORM = 'contact.submit.form';

const TRIGGERS = {
  [CONTACT_SUBMIT_FORM]: {
    name: CONTACT_SUBMIT_FORM,
    displayName: 'Contact submits a form',
  },
};
const CONTACT_SUBSCRIBE_CONTACT_LIST = 'contact.subscribe.contactList';
const CONTACT_ENTER_PIPELINE = 'contact.enter.pipeline';
const CONTACT_UPDATE_FIELD = 'contact.update.field';
const CONTACT_SEND_EMAIL = 'contact.send.email';
const CONTACT_SEND_SMS = 'contact.send.sms';
const CONTACT_NOTIFY_SOMEONE = 'contact.notify.someone';
const CONTACT_ASSIGN_MEMBER = 'contact.assign.member';

const ACTIONS = {
  [CONTACT_SUBSCRIBE_CONTACT_LIST]: {
    name: CONTACT_SUBSCRIBE_CONTACT_LIST,
    displayName: 'Subscribe Contact to a list',
  },
  [CONTACT_ENTER_PIPELINE]: {
    name: CONTACT_ENTER_PIPELINE,
    displayName: 'Enter Contact to a Pipeline',
  },
  [CONTACT_UPDATE_FIELD]: {
    name: CONTACT_UPDATE_FIELD,
    displayName: 'Update Contact field',
  },
  [CONTACT_SEND_EMAIL]: {
    name: CONTACT_SEND_EMAIL,
    displayName: 'Send email to Contact',
  },
  [CONTACT_SEND_SMS]: {
    name: CONTACT_SEND_SMS,
    displayName: 'Send SMS to Contact',
  },
  [CONTACT_NOTIFY_SOMEONE]: {
    name: CONTACT_NOTIFY_SOMEONE,
    displayName: 'Notify Someone',
  },
  [CONTACT_ASSIGN_MEMBER]: {
    name: CONTACT_ASSIGN_MEMBER,
    displayName: 'Assign Contact to a Member',
  },
};

export default {
  components: {
    VDropdown,
    VDropdownMenu,
  },

  props: {
    automation: {
      type: Object,
      required: true,
    },
  },

  methods: {
    getTriggerName(name) {
      if (!TRIGGERS[name] || !TRIGGERS[name].displayName) return name;
      return TRIGGERS[name].displayName;
    },

    getActionName(name) {
      if (!ACTIONS[name] || !ACTIONS[name].displayName) return name;
      return ACTIONS[name].displayName;
    },
  },
};
</script>
